import { css, jsx } from '@emotion/core';
import { Tag, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import { colors } from '@/styles';

const style = {
  filterTag: css`
    height: 30px;
    min-width: 83px;
    border-radius: 2px;
    border: 1px solid ${colors.accentGrayLight};
    background-color: #fff;
    font-size: 1.2rem;
    display: inline-flex !important;
    align-items: center;
    font-weight: 900;
    .anticon-close {
      color: ${colors.secondaryGray};
      font-size: 1.4rem;
      margin-left: auto;
      margin-right: 4px;
      transform: translateX(4px);
    }
  `,
};

const SearchTag = ({ tag, tagClose }) => {
  const { children, value, input } = tag;
  if (!children) return null;
  const childrenStr = children.toString();
  const isLongTag = childrenStr.length > 25;
  const tagNode = (
    <Tag
      css={style.filterTag}
      key={`${input}--${value}`}
      closable
      onClose={e => tagClose(e, value, input)}
    >
      {isLongTag ? `${childrenStr.slice(0, 25)}...` : childrenStr}
    </Tag>
  );

  return isLongTag ? (
    <Tooltip title={childrenStr} key={`${input}--${value}`}>
      {tagNode}
    </Tooltip>
  ) : (
    tagNode
  );
};

SearchTag.propTypes = {
  tag: PropTypes.object.isRequired,
  tagClose: PropTypes.func.isRequired,
};

export default SearchTag;
